export const settingsTranslationHE = {
  settings: {
    "title": "הגדרות",
    'preferences': 'העדפות',
    "account": "חשבון"
  }
}